import { useLanguage } from '../i18n/LanguageContext';
import type { Locale } from '../i18n/copy';

const languages: Array<{ locale: Locale; label: string }> = [
  { locale: 'uk', label: 'UA' },
  { locale: 'ru', label: 'RU' },
  { locale: 'en', label: 'EN' },
];

export function LanguageSwitch() {
  const { locale, setLocale, t } = useLanguage();

  return (
    <div className="language-switch" role="group" aria-label={t.languageLabel}>
      {languages.map((language) => (
        <button
          className={language.locale === locale ? 'is-active' : undefined}
          key={language.locale}
          type="button"
          onClick={() => setLocale(language.locale)}
          aria-pressed={language.locale === locale}
        >
          {language.label}
        </button>
      ))}
    </div>
  );
}
